import { RDisplay } from "../../../../ui/RotDisplay";
import { Actor } from "../../../actors/Actor";
import Colors from "../../../Colors";
import {
  damageWithForce,
  hasStrength,
  reduceDamage,
} from "../../../items/formulas";
import { Attack } from "../../../items/Item";

export const drawShieldDetails = (
  display: RDisplay,
  actor: Actor,
  attack: Attack,
  x: number,
  y: number,
  maxWidth: number,
  color: string
) => {
  let o = 1;
  o += display.drawText(
    x,
    y + o,
    `%c{${hasStrength(actor, attack) ? color : Colors.RED_2}}Str Req: ${
      attack.strength || 0
    }`,
    maxWidth
  );
  o += display.drawText(
    x,
    y + o,
    `%c{${color}}Stability: ${attack.stability || 0}`,
    maxWidth
  );
  o += display.drawText(
    x,
    y + o,
    `%c{${color}}Block:    ${(attack.blocks || 0) * 100}`,
    maxWidth
  );
  o += display.drawText(
    x,
    y + o,
    `%c{${color}}STA Cost: ${attack.stamina || 0}`,
    maxWidth
  );
  return o;
};

export const drawAttackDetails = (
  display: RDisplay,
  actor: Actor,
  attack: Attack,
  x: number,
  y: number,
  maxWidth: number,
  color: string
) => {
  let o = 1;
  o += display.drawText(
    x,
    y + o,
    `%c{${hasStrength(actor, attack) ? color : Colors.RED_2}}Str Req: ${
      attack.strength || 0
    }`,
    maxWidth
  );
  o += display.drawText(
    x,
    y + o,
    `%c{${color}}DMG:      ${reduceDamage(
      damageWithForce(attack.damage || 0, actor.attributes.force),
      1
    )}`,
    maxWidth
  );
  o += display.drawText(
    x,
    y + o,
    `%c{${color}}Poise:    ${attack.poise}`,
    maxWidth
  );
  o += display.drawText(
    x,
    y + o,
    `%c{${color}}STA Cost: ${attack.stamina || 0}`,
    maxWidth
  );
  return o;
};
